import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import EditIcon from '@material-ui/icons/Edit'
import { useSelector } from 'react-redux';
import { Button, Typography } from '@material-ui/core';

const InfoHeader = (props) => {
    const { addInfoClicked, editInfoClicked, info, isOwner, isContributor } = props;
    const [infoOpen, setInfoOpen] = useState(false);
    const isAdmin = useSelector((state) => state.user.admin);

    const handleAddInfoClicked = (e) => {
        e.stopPropagation();
        addInfoClicked();
    }

    return (
        <>
            <div className='info-header'>
                <div className='info-header__title' id='info-header-title' onClick={() => setInfoOpen(!infoOpen)}>
                    <div className='info-header__title-text-container'>
                        <div className='info-header__title-text'>Dashboard Info</div>
                        {infoOpen ? (
                            <KeyboardArrowDownIcon className='info-header__title-icon' />
                        ) : (
                            <KeyboardArrowRightIcon className='info-header__title-icon' />
                        )}
                    </div>
                    {infoOpen && (isOwner || isAdmin || isContributor) && (
                        <Button
                            color='primary'
                            size='small'
                            variant='contained'
                            onClick={(e) => handleAddInfoClicked(e)}
                            className='info-header__add-info-btn'
                        >
                            Add Info
                        </Button>
                    )}
                </div>
                {infoOpen && info.length === 0 && <Typography className='info-header__grid'>No dashboard info has been added</Typography>}
                {infoOpen &&
                    info.length > 0 &&
                    info.map((infoItem, index) => {
                        return (
                            <Grid container key={index} className='info-header__grid'>
                                <Grid className='info-header__grid-title'>
                                    <Typography className='info-header__item-title'>{infoItem.title}</Typography>
                                </Grid>
                                <Grid className='info-header__grid-body'>
                                    <div className='info-header__item-body-row'>
                                        <Typography>{infoItem.body}</Typography>
                                        {(isOwner || isAdmin || isContributor) && <EditIcon onClick={() => editInfoClicked(infoItem)} fontSize='small' className='info-header__edit-icon' />}
                                    </div>
                                </Grid>
                            </Grid>
                        );
                    })}
            </div>
            {infoOpen && <div className='info-header__divider' />}
        </>
    );
};

export default InfoHeader;
